import { AdviseCurrentSupplier } from '../../../../types/advise';
import { TextBlock } from '../../../Atoms/Text';
import { dollars } from './currentSupplierSpend';

/** The supplier's in-scope monthly amount and its annual value, as upstack_api calculated them. */
export const BaselineAmount = ({ supplier }: { supplier: AdviseCurrentSupplier }) => (
  <>
    <TextBlock
      size="xxl"
      weight="semibold"
      color="blue2">
      {dollars(supplier.monthly_amount)}
    </TextBlock>
    <TextBlock
      size="xs"
      color="grey6">
      {`${dollars(supplier.annualized_amount)} annualized`}
    </TextBlock>
  </>
);
